import { Directive, ContentChildren, QueryList, HostBinding, AfterContentInit } from '@angular/core';
import { AccordionElementDirective } from './accordion-element.directive';

@Directive({
  selector: '[appAccordion]'
})
export class AccordionDirective implements AfterContentInit {

  private selectedId: string;

  @HostBinding('class') class = 'accordion';

  @ContentChildren(AccordionElementDirective) panels: QueryList<AccordionElementDirective>;

  constructor() { }

  public toggle(id: string) {
    let allClosed = true;
    this.panels.forEach(p => {
      p._expanded = p.id === id && !p._expanded;
      allClosed = !p._expanded && allClosed;
    });
    this.selectedId = allClosed ? null : id;
  }

  ngAfterContentInit(): void {
    this.panels.forEach(item => {
      item.triggerClick.subscribe((id: string) => {
        // close if already open
        this.openSingle(this.selectedId === id ? null : id);
      });
    });
  }

  /**
   * Open panel with given id, close others
   *
   * @param {string} id
   * @memberof ClxAccordionComponent
   */
  public openSingle(id: string) {
    this.panels.forEach(p => {
      p.setExpanded(p.id === id);
    });
    this.selectedId = id;
  }

}
